import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#252729",
              d: "M6.617 10.858l.09.048.075.056c.204.177.27.468.164.717l-.048.09-.966 1.513h8.86l.084.006c.306.042.54.303.54.62 0 .314-.23.573-.532.618l-.092.007-8.872-.001.981 1.57.043.082c.122.28.025.613-.241.78-.264.164-.602.109-.8-.117l-.062-.082-1.58-2.526-.012-.02-.018-.036-.011-.023-.012-.028-.015-.043-.013-.055-.008-.046-.004-.06.002.044-.001-.014-.002-.03v-.04l.003-.048c.002-.02.006-.04.01-.06l.007-.032c.005-.02.012-.039.018-.057l.022-.052.019-.034-.014.025-.01.022c.013-.031.03-.061.049-.09l1.573-2.465.056-.074c.177-.205.469-.271.717-.165zm7.066-7.31l.056.074 1.574 2.466.026.043.012.024-.033-.058.037.067.023.052.018.057.004.016.003.016c.005.02.008.042.01.063l.003.036v.061l-.002.023-.001.01-.01.063c-.003.017-.008.035-.013.053l-.015.044-.012.027-.01.024-.019.035-.012.02-1.58 2.526c-.183.293-.569.382-.861.199-.267-.167-.364-.5-.242-.78l.043-.081.982-1.57H4.792c-.346 0-.625-.28-.625-.625 0-.316.235-.578.54-.62l.085-.005h8.859l-.966-1.513c-.169-.265-.114-.608.116-.808l.075-.055c.264-.17.608-.114.807.116z",
              transform: "translate(-934 -410) translate(928 404) translate(6 6)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }